module.exports = __webpack_public_path__ + "static/media/history_empty.401f826d.png";